// this comment tells babel to convert jsx to calls to a function called jsx instead of React.createElement
/** @jsxImportSource @emotion/react */

import React from 'react';
import { jsx, css } from '@emotion/react'

// example of string styles
const hotPinkStyleVar = css`
  color: hotpink;
  &:hover {
    color: #61dafb;
  }
`

// example of object styles
const objectStyleVar = {
  backgroundColor: '#61dafb',
  padding: '5px',
  '&:hover': {
    color: 'lightgreen'
  }
}

// example of color varable (to import into inline string style)
const colorVar = 'teal'


const StyleDemo = () => {
  return (
    <>

      {/* String Styles - Inline */}
      <div
        css={css`
          background-color: ${colorVar};
          font-size: 0.8em;
          padding: 5px
        `}
      >
        String Style: teal background.
      </div>

      {/* String Styles - Variable */}
      <div css={hotPinkStyleVar}>
        String Style: hotpink.
      </div>

      {/* Object Styles - Inline */}
      <div
        css={{
          backgroundColor: 'hotpink',
          '&:hover': {
            color: 'black'
          }
        }}
      >
        Object Style: hotpink background.
      </div>

      {/* Object Styles - Variable */}
      <div css={objectStyleVar}>
        Object Style: blue.
      </div>

    </>
  );
}

export default StyleDemo;
